




























































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import FileList from '@/components/file_list'


export default {
    name: 'formations_table'
    components: {FileList}
    props:
        component:
            type: String
            required: true
        reload:
            type: Boolean
            required: false

    watch:
        reload: (new_reload, old_reload)->
            if new_reload != old_reload
                @get_formations()

    data: ()->
        alert: false
        loading: true
        search: ''
        pager_count: 5
        current_page: 1
        page_size: 10
        unity_options: @$store.state.unity_options
        formations: []
        state_classes: @$store.state.state_classes

    computed:
        data_filtered: ()->
            self = @
            data = @formations.filter (x) ->
                duration = false
                location = organization = ''
                start_date = self.date_formatter(x.start)
                end_date = self.date_formatter(x.end)
                user_str = ''
                if self.component == 'company'
                    user_str = x.user_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())
                if x.duration?
                    duration = x.duration.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())
                if x.location?
                    location = x.location.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())
                if x.organization?
                    organization = x.organization.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())

                !self.search || user_str \
                || x.user_in_charge_str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user_in_charge_str.toLowerCase().includes(self.search.toLowerCase())\
                || x.formation_type.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.formation_type.label.toLowerCase().includes(self.search.toLowerCase())\
                || x.funding.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.funding.label.toLowerCase().includes(self.search.toLowerCase())\
                || start_date.includes(self.search.toLowerCase())\
                || end_date.includes(self.search.toLowerCase())\
                || x.reason.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.reason.toLowerCase().includes(self.search.toLowerCase())\
                || x.location.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())|| x.location.toLowerCase().includes(self.search.toLowerCase())\
                || x.organization.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase())|| x.location.toLowerCase().includes(self.search.toLowerCase())\
                || x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.name.toLowerCase().includes(self.search.toLowerCase())\
                || x.state.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.state.label.toLowerCase().includes(self.search.toLowerCase())\
                || duration
            return data

        data_paged: ()->
            data = @data_filtered.slice(((@current_page - 1) * @page_size), (@page_size * @current_page))
            return data

        has_mutation_right: ()->
            return @has_access_right('formations_self_edit')

        has_deletion_right: ()->
            return @has_access_right('formations_self_delete')

        has_validation_right: ()->
            return @has_access_right('formations_validate')

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        cancellation: (formation)->
            # console.log 'CANCELLATION F ', formation
            new_state = 'annulation_demandee'
            text = "demander l'annulation de cette formation"
            if formation.state.slug == 'annulation_demandee'
                new_state = 'accepte'
                text = "retirer la demande d'annulation"
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    formation.state = t.deep_copy(state)
                    @$emit('cancellation', formation, text)
                    return

        cancel_action_text: (state)->
            ret = "Demander l'annulation"
            if state == "annulation_demandee"
                ret = "Retirer la demande d'annulation"
            return ret

        listen_sort: ({ column, prop, order })->
            # console.log "LISTEN", column, prop, order
            self = @
            @formations.sort (a,b)->
                field_a = field_b = ""
                if prop in ['formation_type.label', 'funding.label']
                    props = prop.split('.')
                    field_a = a[props[0]][props[1]]
                    field_b = b[props[0]][props[1]]
                else if prop in ['duration']
                    if a[prop] != null
                        field_a = a[prop].toString()
                    if b[prop] != null
                        field_b = b[prop].toString()
                else if prop == 'state'
                    field_a = a[prop]['slug']
                    field_b = b[prop]['slug']
                else
                    if a[prop] != null
                        field_a = a[prop]
                    if b[prop] != null
                        field_b = b[prop]
                modifier = 1
                if order == 'descending'
                    modifier = -1
                return field_a.toLowerCase().localeCompare(field_b.toLowerCase())*modifier
            # console.log "FORMATIONS SORT ", @formations

        handle_size_change: (val)->
            @page_size = val

        handle_current_change: (val)->
            @current_page = val

        download_file: (formation)->
            url = settings.media_url+formation.program_dir+'/'+formation.program
            filename = formation.complete_filename
            t.download_file(url, filename)
            return

        edit_formation: (formation)->
            # console.log 'EDIT F ', formation
            @$emit('edit-formation', formation)
            return

        delete_formation: (formation_uid)->
            @$emit('delete-formation', formation_uid)
            return

        accept_formation: (formation)->
            old_state_slug = formation.state.slug
            new_state = "accepte"
            if old_state_slug == "annulation_demandee"
                new_state = "annule"
            formation.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    formation.state = t.deep_copy(state)
                    @$emit('accept-formation', formation, old_state_slug)
                    return

        refuse_formation: (formation)->
            old_state_slug = formation.state.slug
            new_state = "refuse"
            if old_state_slug == "annulation_demandee"
                new_state = "accepte"
            formation.user_in_charge_uid = @$store.state.user_datas.app_user.uid
            for state in @$store.state.state_choice_set
                if state.slug == new_state
                    formation.state = t.deep_copy(state)
                    @$emit('refuse-formation', formation, old_state_slug)
                    return

        get_formations: ()->
            self = @
            @loading = true
            q.run('get_formation_set', [@$store.getters.current_company.uid, @component])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error(self.component+"_formations: get_formations: then", e.message)
                else
                    # console.log "GET formations : ", resp.body.data.formation_set
                    self.formations = resp.body.data.formation_set
                    self.loading = false
                    if self.formations.length == 0
                        self.alert = true
                    else
                        self.alert = false
            .catch (resp)->
                n.catch_error(resp, "formations_table: get_formations()")

    beforeMount: ()->
        # console.log "formations_table mounted"
        @get_formations()
}
